/* eslint-disable react/jsx-no-comment-textnodes */
import * as React from 'react';
import { AlertInlineMain } from '@inmoment/the-kitchen';

export interface Props {}

export const CondensedExperienceCardDocumentation: React.FC<Props> = (props) => {
  return (
    <div>
      <AlertInlineMain
        color="warning"
        title="Note!"
        subtitle="The CondensedExperienceCard follows the same pattern for IconButtons as the ExperienceCard, see ExperienceCard documentation for details."
      />
    </div>
  );
};
